import i18n from '@/i18n'
import { mapActions } from 'vuex'
import Vue from 'vue'
import { EventHub } from "@/constants/constants"
import { DialogEventConfiguration } from '@/tools/dialog'
import { mapGetters } from "vuex"
import EventConfigurationTabComponent from './event-configuration/EventConfigurationTabComponent.vue'
import { clone } from 'ramda'

export default {
    name: 'EventConfigurationDialogComponent',
    components: {
        EventConfigurationTabComponent
    },
    props: {
    },
    data: () => ({
        // reglas de validación
        validationRules: {
            required: (value) => !!value || value === 0 || `${i18n.t('required')}`,
            requiredState: (value, state) => !state || !!value || value === 0 || `${i18n.t('required')}`,
            noDuplicateEvent: (eventNumbers, value) => !eventNumbers.find(e => e === value) || `${i18n.t('error.duplicateEvent')}`
        },
        // números de eventos actguales, para evitar duplicados
        eventNumbers: [],
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // indica si se está actualizando una empresa
        update: false,
        // componente con tabla editable de configuración
        configurationComponent: {
            content: {
                _uid: 'SDTtsTA1iw',
                component: 'EventConfigurationTabComponent',
                headline: 'EventConfigurationTabComponent'
            },
            model: {},
            validForm: false,
            selectedType: undefined
        },
        // indica si se está dentro del dialogo de edicion de evento, para manejar la clonación del modelo cuando cambia el bread
        editingEvent: false
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        })
    },
    created () {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
        (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastBreadcrumb = this.getBread[newBreads.length - 1]
                if (!lastBreadcrumb) {
                    this.cancel()
                } else {
                    if (lastBreadcrumb.key === DialogEventConfiguration) {
                        if (!this.editingEvent) {
                            this.configurationComponent.model = clone(lastBreadcrumb.model)
                            this.update = lastBreadcrumb.update
                            this.configurationComponent.selectedType = lastBreadcrumb.selectedType
                        }
                        this.editingEvent = false
                    }
                }
            },
        { deep: true })
    },
    mounted () {
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogEventConfiguration) {
                if (!this.editingEvent) {
                    this.configurationComponent.model = clone(lastBreadcrumb.model)
                    this.update = lastBreadcrumb.update
                    this.configurationComponent.selectedType = lastBreadcrumb.selectedType
                }
                this.editingEvent = false
            }
        }
    },
    beforeDestroy () {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.configurationComponent.model = {}
            this.editingEvent = false
            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogEventConfiguration)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const eventConfiguration = this.getEventConfiguration()
            this.cancel()
            this.$eventBus.$emit(EventHub.COMMIT_EVENT_CONFIGURATION, eventConfiguration)
        },
        /**
         * Genera el objeto que se guarda en la empresa
         */
        getEventConfiguration() {
            Object.keys(this.configurationComponent.model.eventConfigurations).forEach(type => {
                if (this.configurationComponent.model.eventConfigurations[type].length <= 0) {
                    this.configurationComponent.model.eventConfigurations[type] = []
                }
            })
            return this.configurationComponent.model.eventConfigurations
        },
        /**
         * Retorna un boolean para habilitar / deshabilitar el botón save
         */
        disableSaveBtn () {
            return !this.configurationComponent.validForm
        },
    }
}
